import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Geriatric icon
 *
 * @category Medical
 */
const Geriatric = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M21.476 4.522c-2.1-1.93-5.51-1.99-8.49-.03-.94.51-2.47.42-3 1.48-.62 1.31.76 2.54 2.06 2.36.51-.02.84-.11.9-.03.06.2.01 1.08.03 2.35v17.67c.26.91 1.51.54 2.42.62.82 0 1.52.04 1.63-.67v-20.7c.06-.69-.29-1.18.69-1.1 1.2.02 2.01 1.41 3.28 1.01 1.26-.31 1.57-2.07.6-2.86l-.12-.11zm-7.42 23.31c-.05-.08-.19-1.92.17-1.89.45-.04 1.29-.13 1.67.06.16.12.1.55.11 1.03 0 .48.03.79-.22.86-.5.05-1.2.09-1.67 0zm1.78-2.88c-.22.03-1.52.15-1.74-.13-.13-.21-.08-.67-.09-1.04V8.072c.11-.53 1.09-.87 1.62-1.2.26-.07.37 0 .38.36-.09 5.01.21 12.94-.1 17.67zm5.18-18.55c-.17.14-.49.17-.79.06-3.56-2.4-4.62-.04-7.83.87-.71.25-2.11-.26-1.34-1.11.65-.41 1.75-.42 2.45-.91 2.28-1.41 4.98-1.94 7.07-.25.41.26.81.83.53 1.24l-.09.09z"
        />
      </svg>
    );
  }
);

Geriatric.displayName = 'Geriatric';

export { Geriatric };
